module.exports = __webpack_public_path__ + "img/forgot-password.d3323ca9.jpg";